import React, { useState, useCallback } from "react";
import { useQuery } from "@apollo/react-hooks";
import { GLOBAL_SEARCH } from "../../../graphql/modules";
import { Link, useHistory } from "react-router-dom";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import Highlighter from "react-highlight-words";
import { debounce } from "lodash";

const DrawerLeft = ({
  menuDrawerClassName,
  openMenuDrawer,
  wrapRefMenu,
  aboutCategory,
}) => {
  const [searchTxt, setSearchTxt] = useState("");
  const [debouncedSearchTxt, setDebouncedSearchTxt] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  const categoryList = useSelector((state) => state.categories);

  // Create debounced function
  const debouncedSearch = useCallback(
    debounce((searchValue) => {
      setDebouncedSearchTxt(searchValue);
      setIsTyping(false);
    }, 300),
    []
  );

  // Handle input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTxt(value);
    setIsTyping(true);
    debouncedSearch(value);
  };

  const { data: searchData, loading } = useQuery(GLOBAL_SEARCH, {
    variables: {
      searchTxt: debouncedSearchTxt,
    },
    skip: !debouncedSearchTxt,
    fetchPolicy: "network-only", // Changed to network-only for fresh data
  });

  // Only process data when we have the correct search results
  const shouldShowResults = debouncedSearchTxt && !isTyping && !loading;
  
  let resultOfProduct = [];
  let suggestProduct = [];
  let suggestSubcategory = [];
  let suggestCategory = [];

  if (shouldShowResults && searchData?.FetchGlobalSearchProduct) {
    suggestProduct = searchData.FetchGlobalSearchProduct.products?.map(
      ({ name, _id, category, subcategory }) => {
        let productFromCategory = [];
        let productFromSubcategory = [];
        if (category?.length) {
          productFromCategory = category.map((ctPro) => ({
            name,
            _id,
            type: "category",
            ref: ctPro?._id,
            parentName: ctPro?.name,
          }));
        }
        if (subcategory?.length) {
          productFromSubcategory = subcategory.map((ctPro) => ({
            name,
            _id,
            type: "subcategory",
            ref: ctPro?._id,
            parentName: ctPro?.name,
          }));
        }
        resultOfProduct.push(...productFromSubcategory, ...productFromCategory);
        return { name, _id };
      }
    ) || [];
    
    suggestSubcategory = searchData.FetchGlobalSearchProduct.subcategories || [];
    suggestCategory = searchData.FetchGlobalSearchProduct.categories || [];
  }

  const history = useHistory();

  useEffect(() => {
    setSearchTxt("");
    setDebouncedSearchTxt("");
    setIsTyping(false);
  }, [menuDrawerClassName]);
  
  const onRedirect = (_id, isProduct = false, isCategory = false, ref) => {
    if (isCategory) {
      history.push(`/category/${_id}?type=categoryId`);
    } else if (isProduct) history.push(`/products/${_id}?ref=${ref}`);
    else history.push(`/category/${_id}?type=subcategoryId`);
  };

  useEffect(() => {
    const mt =
      (document.querySelector("#lempor_rasel")?.offsetHeight || 0) +
      document.querySelector(".navbar-area").offsetHeight;
    wrapRefMenu.current.style.setProperty("top", mt + `px`, "important");
  }, [menuDrawerClassName]);

  return (
    <section
      className={`leftdrawer ${menuDrawerClassName ? "overlay" : ""}`}
      id="drawer"
    >
      <div
        ref={wrapRefMenu}
        className={`inner-drawer ${menuDrawerClassName ? "" : ""}`}
        style={{ position: "fixed" }}
      >
        <nav
          className={`animated bounceInDown ${
            menuDrawerClassName ? "" : "d_n"
          }`}
          style={{ cursor: "auto" }}
        >
          {/* <!-- Mobile Search Bar --> */}

          {/* <!-- Mobile Search Bar End --> */}

          <div className="left-side-menubar">
            <div className="inner-left-side-menubar">
              <div className="mobile_search visibility_mobile_search">
                <div className="mobile-inner-search">
                  <form action="">
                    <div className="input-group">
                      <span
                        className="input-group-text mobile-search-input-text"
                        id="basic-addon1"
                      >
                        <i className="fas fa-search"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control mobile-search-control"
                        placeholder="Search chillfitrave.com"
                        value={searchTxt}
                        onChange={handleSearchChange}
                      />
                      <span
                        className="input-group-text cancel_search"
                        id="basic-addon1"
                        onClick={() => {
                          setSearchTxt("");
                          setDebouncedSearchTxt("");
                          setIsTyping(false);
                        }}
                      >
                        Cancel
                      </span>
                    </div>
                  </form>
                </div>
              </div>
              {debouncedSearchTxt ? (
                <div className="mobile_search_area">
                  <div
                    className="inner_m_search_area"
                    style={{ maxHeight: "84vh", overflow: "auto" }}
                  >
                    {/* Show loading or typing state */}
                    {(isTyping || loading) && (
                      <div className="mb-2">
                        <p style={{ color: "#666", fontStyle: "italic" }}>
                          Searching...
                          {/* {isTyping ? "Typing..." : "Searching..."} */}
                        </p>
                      </div>
                    )}
                    
                    {/* Only show results when we should */}
                    {shouldShowResults && (
                      <>
                        {suggestSubcategory.map(({ name, _id }) => (
                          <div
                            onClick={() => onRedirect(_id, false, false)}
                            className="mb-2"
                            key={_id}
                          >
                            <Highlighter
                              highlightClassName="highlight-class"
                              searchWords={debouncedSearchTxt.split(" ")}
                              textToHighlight={name}
                            />
                          </div>
                        ))}

                        {suggestCategory.map(({ name, _id }) => (
                          <div
                            onClick={() => onRedirect(_id, false, true)}
                            className="mb-2"
                            key={_id}
                          >
                            <Highlighter
                              highlightClassName="highlight-class"
                              searchWords={debouncedSearchTxt.split(" ")}
                              textToHighlight={name}
                            />
                          </div>
                        ))}

                        {resultOfProduct.map(({ name, _id, ref, parentName }) => (
                          <div
                            onClick={() => onRedirect(_id, true, false, ref)}
                            key={ref}
                            className="mb-2"
                          >
                            <Highlighter
                              highlightClassName="highlight-class"
                              searchWords={debouncedSearchTxt.split(" ")}
                              textToHighlight={name + " > " + parentName}
                            />
                          </div>
                        ))}

                        {suggestProduct.length === 0 &&
                          suggestSubcategory.length === 0 &&
                          suggestCategory?.length === 0 && (
                            <ul>
                              <li>
                                <p>
                                  No results for <strong>{debouncedSearchTxt}</strong>
                                </p>
                              </li>
                              <li>
                                <i className="fas fa-chevron-right"></i>
                              </li>
                            </ul>
                          )}
                      </>
                    )}
                  </div>
                </div>
              ) : (
                <div className="accordion" id="accordionExamplewewewe">
                  {categoryList.map((item, cidx) =>
                    item?.subcategoryGroups?.length > 0 ? (
                      <div className="accordion-item" key={item._id}>
                        <h2 className="accordion-header" id={item._id}>
                          <button
                            className="accordion-button accord-menu-btn collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapseOne12${item._id}`}
                            aria-expanded="false"
                            aria-controls={item._id}
                          >
                            <span className="menu-title">
                              {item?.isColored
                                ? [...item?.name].map((letter, idx) => (
                                    <span
                                      key={idx}
                                      style={{
                                        color: getRandomColor(cidx + idx),
                                      }}
                                    >
                                      {letter}
                                    </span>
                                  ))
                                : item?.name}
                            </span>
                          </button>
                        </h2>
                        <div
                          id={`collapseOne12${item._id}`}
                          className="accordion-collapse collapse"
                          aria-labelledby={item._id}
                          data-bs-parent="#accordionExamplewewewe"
                        >
                          <div className="accordion-body submenu-body">
                            <ul>
                              {item.subcategoryGroups?.map((grp) => (
                                <div key={grp?._id}>
                                  <li
                                    className="text-uppercase"
                                    style={{
                                      fontWeight: "bold",
                                      color: "#3d3d3d",
                                    }}
                                  >
                                    {grp?.name}
                                  </li>
                                  {grp?.subcategory?.map((subItem) => (
                                    <li
                                      key={subItem._id}
                                      onClick={openMenuDrawer}
                                    >
                                      <Link
                                        to={`/category/${subItem?._id}?type=subcategoryId`}
                                        className="d-flex"
                                      >
                                        <div className="list-style">
                                          <p className="hover-style">
                                            {subItem?.name}
                                          </p>
                                        </div>
                                      </Link>
                                    </li>
                                  ))}
                                </div>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="accordion-item"
                        style={{
                          padding: "10px",
                          fontWeight: "700",
                          textTransform: "uppercase",
                        }}
                        key={item?._id}
                      >
                        <Link
                          to={`/category/${item?._id}?type=categoryId`}
                          style={{ color: "#3d3d3d" }}
                        >
                          {item?.isColored
                            ? [...item?.name].map((letter, idx) => (
                                <span
                                  key={idx}
                                  style={{
                                    color: getRandomColor(cidx + idx),
                                  }}
                                >
                                  {letter}
                                </span>
                              ))
                            : item?.name}
                        </Link>
                      </div>
                    )
                  )}
                  {aboutCategory?.length > 0 && (
                    <div className="accordion-item">
                      <h2 className="accordion-header" id={"about_us"}>
                        <button
                          className="accordion-button accord-menu-btn collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapseOne12_about_us`}
                          aria-expanded="false"
                          aria-controls={"about_us"}
                        >
                          <span className="menu-title">About us</span>
                        </button>
                      </h2>
                      <div
                        id={`collapseOne12_about_us`}
                        className="accordion-collapse collapse"
                        aria-labelledby={"about_us"}
                        data-bs-parent="#collapseOne12_about_us"
                      >
                        <div className="accordion-body submenu-body">
                          <ul>
                            {aboutCategory?.map((grp) => (
                              <div key={grp?._id}>
                                <li
                                  className="text-uppercase"
                                  style={{
                                    fontWeight: "bold",
                                    color: "#3d3d3d",
                                  }}
                                >
                                  {grp?.name}
                                </li>
                                {grp?.aboutItems?.map((subItem) => (
                                  <li
                                    key={subItem._id}
                                    onClick={openMenuDrawer}
                                  >
                                    <Link
                                      to={`/about?menu=${subItem?._id}`}
                                      className="d-flex"
                                    >
                                      <div className="list-style">
                                        <p className="hover-style">
                                          {subItem?.name}
                                        </p>
                                      </div>
                                    </Link>
                                  </li>
                                ))}
                              </div>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </nav>
      </div>
    </section>
  );
};

export default DrawerLeft;

const getRandomColor = (startIndex) => {
  let colorCodes = ["#4284F4", "#EA4336", "#FABD05", "#34A853", "#EA4336"];
  if (startIndex > colorCodes.length) {
    startIndex = startIndex - colorCodes.length;
  }
  return colorCodes[startIndex];
};